import React from "react";
import { Image, Col, Row, Form } from "react-bootstrap";
import { Menu, MenuItem } from "@material-ui/core";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import SelectFilter from "../../../../reusableComponents/selectFilter";

// Animations
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;
// End Animations

export const FilterSearchSortDownload = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={6}>
          <Row>
            <Image
              onClick={props.searchClick}
              alt="Search"
              title="Search"
              width="80px"
              src={require("../../../../../assets/images/iconButton/newsearchicon.svg")}
            />
            <div className="f10-400" align="center" onClick={props.showFilter}>
              <Image
                src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                width="80px"
                alt="Filter"
                title="Filter"
              />
            </div>
            <div
              className="f10-400"
              align="center"
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <Image
                src={require("../../../../../assets/images/iconButton/sortbtn.svg")}
                width="80px"
                alt="Sort"
                title="Sort"
              />
            </div>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {props.userFilter.map((ele, index) => {
                return (
                  <MenuItem
                    value={ele?.title}
                    key={index}
                    onClick={() => props.setUserSort(ele?.title)}
                    disabled={ele?.disabled}
                  >
                    {ele?.title}
                  </MenuItem>
                );
              })}
            </Menu>
            <div className="f10-400" align="center">
              <CSVDownloader
                filename={props?.downloadFileName}
                headers={props?.headers}
                data={props?.data}
              />
            </div>
          </Row>
        </Col>
        <Col sm={12} md={2} className="offset-md-4">
          <SelectFilter onDateChange={props.onDateChangeHandler} />
        </Col>
        <Col sm={12} md={6}>
          {props.showSearch && (
            <div className="mb-3">
              <ZoomDiv>
                <>
                  <Form.Control
                    type="text"
                    placeholder="Search by business name, diner name"
                    name="search"
                    onChange={props.onSearchChange}
                    value={props.searchInput}
                    className="amSearch"
                  />
                </>
              </ZoomDiv>
            </div>
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};
